import React from 'react';
import Modal from '../shared/Modal';

class MenuEditDishModal extends React.Component {
  state = {};

  render() {
    const { dish, isOpen, closeModal } = this.props;
    return (
      <Modal isOpen={isOpen} onRequestClose={closeModal} className="modal">
        <div className="modal__head">
          <h2 className="h2 modal__heading">Edit a Dish</h2>
          <p className="p menu-dish-edit-modal__p">
            You are about to make changes to a dish. Would you like these
            changes to create a public child dish that is added to the dish
            library or a private child dish that is used for this menu only?
          </p>
          {this.renderCTAs(dish)}
        </div>
      </Modal>
    );
  }

  renderCTAs(dish) {
    const { editMenuDish } = this.props;
    const { parent_dish_id } = dish;
    const isChild = parent_dish_id > 0;

    const editLink = !isChild ? (
      ''
    ) : (
      <div className="row">
        <div className="row__item">
          <div className="a--blue a--center" onClick={() => editMenuDish(dish)}>
            Edit Existing
          </div>
        </div>
      </div>
    );

    return (
      <div className="ctas">
        <div className="form__row">
          <div className="form__row-item form__row-item--half">
            <div
              className="btn btn--hollow-blue btn--full-width"
              onClick={() => editMenuDish(dish, true)}
            >
              Create Public
            </div>
          </div>
          <div className="form__row-item form__row-item--half">
            <div
              className="btn btn--solid-blue btn--full-width"
              onClick={() => editMenuDish(dish, true, true)}
            >
              Create Private
            </div>
          </div>
        </div>
        {editLink}
      </div>
    );
  }
}

export default MenuEditDishModal;



// WEBPACK FOOTER //
// ./src/components/menu/MenuEditDishModal.js